// extracted by css-extract-rspack-plugin
export default {"UpsellCTALink":"UpsellCta-module__UpsellCTALink___aBdyE","Medium":"UpsellCta-module__Medium___RPfNI","Large":"UpsellCta-module__Large___MhOk9"};